<template>
    <div class="content">
        <category-title></category-title>
        <div
            v-html="category.description"
            class="description"
        ></div>
        <div class="controls ta-center">
            <app-button
                @click.native="start"
                type="success"
                align="center"
            >Начать</app-button>
            <a href="/" class="link">На главную</a>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/AppButton.vue';
    import CategoryTitle from '@/components/CategoryTitle.vue';

    export default {
        name: 'CategoryStart',
        components: {
            AppButton,
            CategoryTitle
        },
        computed: {
            category () {
                return this.$store.getters.getCategory;
            }
        },
        methods: {
            start () {
                this.$store.dispatch('nextMessage');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .controls {
        margin-top: 2em;
    }

    .link {
        display: inline-block;
        margin-top: 3em;
    }
</style>